// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"78848f94","260":"8b2ad7e0","295":"09992ff2","653":"e5e87235","787":"aeb39de0","889":"d4cf3bf9"}[chunkId] + ".chunk.js";
};